var ɵ0 = { localeTag: 'ABOUT_US_URL' }, ɵ1 = { localeTag: 'ABOUT_US_URL' }, ɵ2 = { localeTag: 'ABOUT_US_URL' }, ɵ3 = { localeTag: 'ABOUT_US_URL' }, ɵ4 = { localeTag: 'ABOUT_US_URL' };
var AboutRoutingModule = /** @class */ (function () {
    function AboutRoutingModule() {
    }
    return AboutRoutingModule;
}());
export { AboutRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
